/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * Payload language detection, shared by every surface that shows a captured
 * request/response — the demand-source Debug inspector (#867) and the response
 * mapping editor's sample box (#866) — so the same payload highlights the same
 * way wherever it appears.
 *
 * Lives outside PayloadViewer.tsx because a component module may only export
 * components (react-refresh).
 */

export type PayloadLanguage = 'json' | 'xml' | 'text';

/** Guess a viewer language from a payload string (JSON vs XML vs text). */
export function detectPayloadLanguage(payload: string): PayloadLanguage {
  const trimmed = payload.trimStart();
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) return 'json';
  if (trimmed.startsWith('<')) return 'xml';
  return 'text';
}
